import script from "./ServiceDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ServiceDetailView.vue?vue&type=style&index=0&id=d0b9eba6&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0b9eba6"]])

export default __exports__